import { useEffect, useState } from "react";
import AddComment from "./addComment";
import Image from "next/image";
import LikeComment from "./likeComment";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { IComments, ConditionName, ISingleCommentProps } from "interfaces";
import { conditions, getRemainingTime } from "helpers";
import { setReplyToAuthor } from "redux-share/slices/commentsSlice";
import { handleGetReplies } from "redux-share/actions/comment.action";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const EmptyProfileIcon = dynamic(() => import("../../icon-components/emptyProfile"));
const SingleReply = dynamic(() => import("./singleReply"));

const SingleComment = ({ comment, user, commentsLocalStorageIds }: ISingleCommentProps) => {

    const dispatch = useAppDispatch();
    const { realTimeReply } = useAppSelector(({ comments: { realTimeReply, canAddComment } }) => ({ realTimeReply, canAddComment }), shallowEqual);
    const { avatar_url, name } = useAppSelector(({ user: { avatar_url, name } }) => ({ avatar_url, name }), shallowEqual);

    const [showReplyBox, setShowReplyBox] = useState<boolean>(false);
    const [repliesCount, setRepliesCount] = useState<number>(comment.replies_count);
    const [replies, setReplies] = useState<IComments[]>([]);
    const [usersRepliesProfiles, setUsersRepliesProfiles] = useState<any[]>([]);

    useEffect(() => {
        setRepliesCount(comment.replies_count);
    }, [comment.replies_count])


    useEffect(() => {
        if (realTimeReply && comment.id === realTimeReply.reply_to) {
            setReplies([realTimeReply, ...replies]);
            setRepliesCount((prev: number) => prev + 1);
            setUsersRepliesProfiles(prev => [...prev, { id: realTimeReply.author, profile: { avatar_url: avatar_url, name: name}}])
        }
    }, [realTimeReply])


    const handleHideComments = () => {
        setShowReplyBox(false);
        setReplies([]);
    }

    const handleAnswer = () => {
        dispatch(setReplyToAuthor({ author: user ? user.profile.name : "کاربر ناشناس", id: comment.id }));
        if (!conditions(ConditionName.isTouchScreen)) setShowReplyBox(true);

    }

    return (
        <div className="pl-flex pl-flex-col pl-items-start">
            <div className="pl-flex pl-justify-between pl-items-center pl-w-full">
                <div className={`pl-flex pl-items-center pl-gap-1 pl-font-normal ${conditions(ConditionName.isTouchScreen) ? "pl-text-[11px]" : "pl-text-[14px]"}`}>
                    {user && Object.keys(user.profile).length > 0 && user.profile.avatar_url ? <Image src={user.profile.avatar_url} width={24} height={24} alt="user-profile" className="pl-rounded-full"/> : <EmptyProfileIcon />}
                    <p className="pl-text-main-highLight">{user && Object.keys(user.profile).length > 0 ? user.profile.name : "کاربر ناشناس"} .</p>
                    <span className="pl-text-z-secondary-600 dark:pl-text-z-gray-400">{getRemainingTime(comment.created_at)}</span>
                </div>
                <LikeComment commentId={comment.id} likesCount={comment.like} isIdInLocalStorage={!!commentsLocalStorageIds && commentsLocalStorageIds.includes(comment.id)}/>
            </div>
            <p className="pl-text-[13px] pl-font-normal pl-leading-[22px] pl-mt-3 pl-mb-1 pl-text-z-gray-700 dark:pl-text-secondary-50">{comment.text}</p>
            <button disabled={!conditions(ConditionName.canAddComment)} className={`pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-gray-400 ${conditions(ConditionName.isTouchScreen) ? "pl-text-[11px]" : "pl-text-[12px]"}`} onClick={handleAnswer}>پاسخ</button>
            {showReplyBox && <AddComment type="reply" setShowReplyBox={setShowReplyBox} />}
            {!!repliesCount && replies.length === 0 && (
                <div className="pl-flex pl-items-center pl-gap-[5px] pl-mt-1">
                    <div className="pl-w-6 pl-h-[1px] pl-bg-z-secondary-600 pl-rounded-[4px]" />
                    <button className={`pl-text-z-secondary-600 dark:pl-text-z-gray-400 pl-font-normal ${conditions(ConditionName.isTouchScreen) ? "pl-text-[11px]" : "pl-text-[12px]"}`} onClick={() => handleGetReplies(comment.id, replies, setReplies, usersRepliesProfiles, setUsersRepliesProfiles, realTimeReply)}>مشاهده {repliesCount} پاسخ دیگر</button>
                </div>
            )}
            {!!replies.length && (
                <>
                    {replies.map((reply: IComments) => <SingleReply key={reply.id} reply={reply} usersRepliesProfiles={usersRepliesProfiles} commentsLocalStorageIds={commentsLocalStorageIds}/>)}
                    {repliesCount - replies.length <= 0 ? (
                        <div className="pl-flex pl-items-center pl-gap-[5px] pl-mt-1 pl-mr-4">
                            <div className="pl-w-6 pl-h-[1px] pl-bg-z-secondary-600 pl-rounded-[4px]" />
                            <button className="pl-text-z-gray-400 pl-text-[11px] pl-font-normal" onClick={handleHideComments}>پنهان کردن پاسخ ها</button>
                        </div>
                    ) : (
                        <div className="pl-flex pl-items-center pl-gap-[5px] pl-mt-1 pl-mr-4">
                            <div className="pl-w-6 pl-h-[1px] pl-bg-z-secondary-600 pl-rounded-[4px]" />
                            <button className="pl-text-z-gray-400 pl-text-[11px] pl-font-normal" onClick={() => handleGetReplies(comment.id, replies, setReplies, usersRepliesProfiles, setUsersRepliesProfiles)}>مشاهده {repliesCount - replies.length} پاسخ دیگر</button>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default SingleComment;